<template>
  <v-container>
    <v-layout wrap>
      <v-row no-gutters>
        <v-col cols="12">
          <user-management />
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import UserManagement from "@/components/UserManagement";

export default {
  components: {
    UserManagement
  }
};
</script>
